/* @flow */
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import BoxBody from 'components/BoxBody.jsx';
import PaymentAccount from 'entities/PaymentAccount';
import StripePersonalNumberForm from 'payments/components/StripePersonalNumberForm.jsx';
import ToastActions from 'actions/ToastActions';
import EncryptionNotice from 'components/EncryptionNotice.jsx';
import Link from 'components/Link.jsx';

const dialogSubtext = (
  <span>
    <Link target="_blank" href="http://www.stripe.com">Stripe</Link>, our payment processor,
    needs your full Social Security number to complete this transaction.
    We don’t store this information on Remind’s servers.
  </span>
);

type Props = {
  patchPII: (pii: Object) => Promise<void>,
  onRequestHide: () => void,
  account: PaymentAccount,
};

type State = {
  proccessing: boolean,
};

class IdentityAdditionalVerificationModal extends React.Component {
  props: Props;

  state: State = {
    proccessing: false,
  };

  onValidSubmit = (token: string) => {
    function onSuccess() {
      ToastActions.showSuccessToast('Account saved.');
      this.props.onRequestHide();
    }

    function onError(error) {
      ToastActions.showAPIError(error);
    }

    this.setState({ proccessing: true });

    this.props
      .patchPII({ personal_id_number: token })
      .then(onSuccess, onError)
      .then(() => this.setState({ proccessing: false }));
  }

  render() {
    return (
      <Dialog
        eventScreenName="IdentityAdditionalVerificationModal"
        {...this.props}
        size="small"
        subtext={dialogSubtext}
        title="Looks like we need a little more information"
        className="IdentityAdditionalVerificationModal">
        <BoxBody>
          <StripePersonalNumberForm
            disabled={this.state.proccessing}
            onValidSubmit={this.onValidSubmit}
          />
          <EncryptionNotice />
        </BoxBody>
      </Dialog>
    );
  }
}

export default IdentityAdditionalVerificationModal;



// WEBPACK FOOTER //
// ./src/payments/components/IdentityAdditionalVerificationModal.jsx